import React, { useEffect, useState, useRef } from "react";
import "./Notification.scss";
import { __ } from "@wordpress/i18n";
import apiFetch from "@wordpress/api-fetch";

const Notification = ({ onClose }) => {
	const [histories, setHistories] = useState([]);
	const [isVisible, setIsVisible] = useState(true);
	const [animationState, setAnimationState] = useState('initial');
	const componentRef = useRef(null);

	useEffect(() => {
		// Trigger show animation after initial render
		const timer = setTimeout(() => {
			setAnimationState('show');
		}, 50);

		return () => clearTimeout(timer);
	}, []);

	useEffect(() => {
		fetchHistories();
	}, []);

	const fetchHistories = async () => {
		try {
			const data = await apiFetch({
				path: "/ultimate-security/v1/get-histories",
			});
			setHistories(data);
		} catch (err) {
			console.error("Error fetching histories:", err);
		}
	};

	function timeAgo(inputDate) {
		// Parse the input date as UTC
		const pastDate = new Date(inputDate + " UTC");
		const now = new Date();

		const nowUTC = Date.UTC(
			now.getUTCFullYear(),
			now.getUTCMonth(),
			now.getUTCDate(),
			now.getUTCHours(),
			now.getUTCMinutes(),
			now.getUTCSeconds(),
		);
		const pastDateUTC = Date.UTC(
			pastDate.getUTCFullYear(),
			pastDate.getUTCMonth(),
			pastDate.getUTCDate(),
			pastDate.getUTCHours(),
			pastDate.getUTCMinutes(),
			pastDate.getUTCSeconds(),
		);

		const diffInSeconds = Math.floor((nowUTC - pastDateUTC) / 1000);

		const units = [
			{ label: "year", seconds: 60 * 60 * 24 * 365 },
			{ label: "month", seconds: 60 * 60 * 24 * 30 },
			{ label: "week", seconds: 60 * 60 * 24 * 7 },
			{ label: "day", seconds: 60 * 60 * 24 },
			{ label: "hour", seconds: 60 * 60 },
			{ label: "minute", seconds: 60 },
			{ label: "second", seconds: 1 },
		];

		for (const unit of units) {
			const count = Math.floor(diffInSeconds / unit.seconds);
			if (count > 0) {
				return `${count} ${unit.label}${count > 1 ? "s" : ""} ago`;
			}
		}

		return "Just now";
	}

	// Handle closing the notification
	const handleClose = () => {
		setAnimationState('hide');
		
		// Slight delay to allow exit animation
		setTimeout(() => {
			setIsVisible(false);
			if (onClose) {
				onClose();
			}
		}, 1000);
	};

	// Close when clicking outside
	useEffect(() => {
		function handleClickOutside(event) {
			if (
				componentRef.current &&
				!componentRef.current.contains(event.target)
			) {
				handleClose();
			}
		}

		// Add event listener
		document.addEventListener("mousedown", handleClickOutside);
		
		return () => {
			// Remove event listener on cleanup
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, []);

	// If not visible, return null
	if (!isVisible) return null;

	return (
		<div className="ultimate-security-notification" ref={componentRef}>
			<div className={`notification-menu ${animationState}`}>
				<div className="notification-header-container">
					<div className="notification-header alt-brand-bg-color">
						<span className="title secondary-text-color">
							{__("Activity Log", "ultimate-security")}
						</span>
						<img
							src={ultimate_security_ajax_obj.imageUrl+'close.svg'}
							alt="close"
							className="close-icon"
							onClick={handleClose}
						/>
					</div>
				</div>
				<div className="histories text-start">
					{histories && Object.values(histories).map((item, index) =>
						item?.message ? (
							<div className="history-unit" key={index}>
								<div className="info">
									{item.display_name && (
										<span className="name">
											{item.display_name}
										</span>
									)}
									{item.created_at && (
										<span className="time-ago">
											{timeAgo(item.created_at)}
										</span>
									)}
								</div>
								<div className="message">
									{item.message}
								</div>
							</div>
						) : null
					)}
				</div>
				<div className="notification-actions">
					<div className="notification-description">
						{__(
							"Stay updated with real-time activities happening on your WordPress site. This timeline provides a detailed overview of key events, helping you track changes and actions.",
							"ultimate-security",
						)}
					</div>
				</div>
				<div className="cta-container">
					<div className="cta-content">
						<div className="cta-text">
							<h3>
								{__("Ready to Get Started?", "ultimate-security")}
							</h3>
							
						</div>
						<a target="_blank" href="https://wpultimatesecurity.com/" className="cta-button purple-bg-40 secondary-text-color" style={{textDecoration: "none"}}>
							{__("Learn More", "ultimate-security")}
						</a>
					</div>
				</div>
			</div>
			<div className={`overlay ${animationState}`} onClick={handleClose}></div>
		</div>
	);
};

export default Notification;